import { Component, Inject, OnInit, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LimitProgressDialogData } from './limit-progress-dialog';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-limit-progress-dialog',
  templateUrl: './limit-progress-dialog.component.html',
  styleUrls: ['./limit-progress-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LimitProgressDialogComponent implements OnInit {
  manualRefresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public dialogRef: MatDialogRef<LimitProgressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public model: LimitProgressDialogData,
  ) {
    this.dialogRef.afterOpened().subscribe(() => this.manualRefresh.emit());
  }

  options: Options = null;

  ngOnInit(): void {
    this.options = {
      floor: 0,
      ceil: 100,
      animate: false,
      showSelectionBar: true,
    };

    if (this.model.maxLockedProgress) {
      this.options.minLimit = this.model.maxLockedProgress;
    }
  }

  setProgress(value: number) {
    if (this.model.maxLockedProgress && value < this.model.maxLockedProgress) {
      return;
    }
    this.model.progress = value;
  }

  confirm(): void {
    this.dialogRef.close(this.model);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
